// --- Axios instance with JWT interceptor ---
import { getConfig } from "@/config";
import axios from "axios";

export const axiosWithAuth = (() => {
  const instance = axios.create();
  // Set baseURL
  instance.interceptors.request.use((config) => {
    const runtimeConfig = getConfig();

    if (!runtimeConfig.API_URL) {
      throw new Error("API_URL is not set in config");
    }

    config.baseURL = runtimeConfig.API_URL;

    return config;
  });
  // Add JWT access token to Authorization header
  instance.interceptors.request.use(async (config) => {
    try {
      const clerk = (window as any).Clerk
      const token = await clerk?.session?.getToken?.()

      if (!token) {
        throw new Error("No authenticated user found")
      }

      config.headers = config.headers || {}
      config.headers['Authorization'] = `Bearer ${token}`
      
      return config
    } catch (error) {
      console.error("Failed to acquire Clerk token:", error)
      throw new Error("Authentication failed", { cause: error })
    }
  });
  return instance;
})();